import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import NewButton from '../../../../../components/NewButton/NewButton';
import { useLanguage } from '../../../../../contexts/LanguageContext';

const SuperAdminTable = ({
    items,
    loading,
    onNew,
    onRemove,
    onPageChange,
    totalRecords,
    pageNumber,
    pageSize,
    isRemoving
}) => {
    const { th } = useLanguage();

    const userBodyTemplate = (rowData) => (
        <div className="flex flex-column">
            <span className="font-medium">{rowData.fullName || '-'}</span>
            {rowData.email && <small className="text-500">{rowData.email}</small>}
        </div>
    );

    const actionBodyTemplate = (rowData) => (
        <div className="flex align-items-center justify-content-center">
            <Button
                icon="pi pi-trash"
                rounded
                text
                severity="danger"
                onClick={() => onRemove(rowData)}
                loading={isRemoving}
                tooltip={th('common.delete')}
                tooltipOptions={{ position: 'top' }}
            />
        </div>
    );

    const header = (
        <div className="flex justify-content-end align-items-center gap-2">
            <NewButton onClick={onNew} label={th('superAdminDefinition.newRecord')} items={[]} className="p-button-sm" />
        </div>
    );

    return (
        <DataTable
            value={items}
            paginator
            showGridlines
            rows={pageSize}
            first={pageNumber * pageSize}
            totalRecords={totalRecords}
            onPage={(e) => onPageChange(e)}
            dataKey="id"
            loading={loading}
            header={header}
            emptyMessage={th('superAdminDefinition.emptyMessage')}
            rowsPerPageOptions={[5, 10, 25, 50]}
            tableStyle={{ minWidth: '40rem' }}
            responsiveLayout="scroll"
        >
            <Column body={actionBodyTemplate} style={{ width: '5%' }} align="center" />
            <Column field="fullName" header={th('superAdminDefinition.user')} body={userBodyTemplate} style={{ minWidth: '24rem' }} />
        </DataTable>
    );
};

export default SuperAdminTable;
